import { RiGithubFill, RiInstagramFill, RiTwitterFill } from 'react-icons/ri';

export const footerLinks = [
  {
    title: 'Instagram',
    icon: <RiInstagramFill />,
    link: '#',
  },
  {
    title: 'Github',
    icon: <RiGithubFill />,
    link: '#',
  },
  {
    title: 'Twitter',
    icon: <RiTwitterFill />,
    link: '#',
  },
];
